/**
 * Two-segment train/eval split bar.
 *
 * `size: 'sm'` (4px, no labels) for the always-visible per-channel sliver.
 * `size: 'lg'` (28px, with embedded labels "{n} training" / "{n} evaluation")
 * for the expanded detail panel.
 */

import React from 'react';

import { cn } from '../../../../../../lib/utils';

interface Props {
  training: number;
  evaluation: number;
  size?: 'sm' | 'lg';
  className?: string;
}

const SplitBar: React.FC<Props> = ({
  training,
  evaluation,
  size = 'sm',
  className,
}) => {
  const total = training + evaluation;
  const trainPct = total > 0 ? (training / total) * 100 : 0;
  const evalPct = total > 0 ? (evaluation / total) * 100 : 0;
  const isLarge = size === 'lg';
  return (
    <div
      className={cn(
        'flex w-full overflow-hidden rounded',
        isLarge ? 'h-7' : 'h-1',
        className,
      )}
      data-testid="split-bar"
      data-size={size}
    >
      {trainPct > 0 && (
        <div
          className="relative flex items-center justify-center bg-primary text-[11px] font-semibold text-primary-foreground"
          style={{ width: `${trainPct}%` }}
        >
          {isLarge && <span>{training.toLocaleString()} training</span>}
        </div>
      )}
      {evalPct > 0 && (
        <div
          className="relative flex items-center justify-center bg-emerald-600 text-[11px] font-semibold text-white"
          style={{ width: `${evalPct}%` }}
        >
          {isLarge && <span>{evaluation.toLocaleString()} evaluation</span>}
        </div>
      )}
    </div>
  );
};

export default SplitBar;
